// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".pagination-controls[data-v-7679fc9c]{display:flex;align-items:center}.text[data-v-7679fc9c]{font-size:1.25rem;line-height:1.5rem;padding-left:30px;padding-right:30px}.navigation-btn[data-v-7679fc9c]{min-width:unset;width:40px;height:40px}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
